import { render } from "./ParentsWorkedInUK.vue?vue&type=template&id=043d6b19"
import script from "./ParentsWorkedInUK.vue?vue&type=script&lang=js"
export * from "./ParentsWorkedInUK.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__